import React, { useEffect, useState, useRef } from "react";
import {
  getAllSection,
  addSection,
  updateSection,
  deleteSection,
} from "../../api/sectionApi";
import { getAllDepartment } from "../../api/departmentApi"; // Import Department API

import { hasRight } from "../../utils/userRights";

export default function Section() {
  const [sections, setSections] = useState([]);
  const [departments, setDepartments] = useState([]); // Store all departments
  const [formData, setFormData] = useState({
    sectionName: "",
    sectionDescription: "",
    departmentID: "",
  });
  const [editId, setEditId] = useState(null);

  const formRef = useRef(null);

  useEffect(() => {
    fetchData();
    fetchDepartments();
  }, []);

  const fetchData = async () => {
    try {
      const secData = await getAllSection();
      setSections(secData.data || secData);
    } catch (error) {
      console.error("Error fetching sections", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const deptData = await getAllDepartment();
      setDepartments(deptData.data || deptData);
    } catch (error) {
      console.error("Error fetching departments", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.sectionName.trim() || !formData.departmentID) {
      alert("Section Name and Department are required.");
      return;
    }
    try {
      if (editId) {
        await updateSection(editId, formData);
        alert("Section updated successfully ✅");
      } else {
        await addSection(formData);
        alert("Section created successfully 🎉");
      }
      setFormData({ sectionName: "", sectionDescription: "", departmentID: "" });
      setEditId(null);
      fetchData();
    } catch (error) {
      console.error("Error saving section", error);
      alert("Something went wrong while saving section.");
    }
  };

  const handleEdit = (item) => {
    setFormData({
      sectionName: item.sectionName,
      sectionDescription: item.sectionDescription || "",
      departmentID: item.departmentID, // ✅ Pre-fill department ID
    });
    setEditId(item.sectionID);

    formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this section?")) {
      try {
        await deleteSection(id);
        alert("Section deleted successfully 🗑️");
        fetchData();
      } catch (error) {
        console.error("Error deleting section", error);
        alert("Failed to delete section");
      }
    }
  };

  const handleClear = () => {
    setFormData({ sectionName: "", sectionDescription: "", departmentID: 0 });
    setEditId(null);
  };

return (
  <div className="container mt-4 compact-table-container" >
    {/* Heading */}
    <h4 className="compact-heading">Section Details</h4>

    {/* Add / Edit Form */}
    <form ref={formRef} className="row g-2 mt-0 compact-form" onSubmit={handleSubmit}>
      <div className="col-md-3">
        <label className="form-label">
          Section Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          value={formData.sectionName}
          onChange={(e) =>
            setFormData({ ...formData, sectionName: e.target.value })
          }
          required
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">
          Department <span className="text-danger">*</span>
        </label>
        <select
          className="form-select"
          value={formData.departmentID}
          onChange={(e) =>
            setFormData({ ...formData, departmentID: e.target.value })
          }
          disabled={!!editId} // disable if editing
          required
        >
          <option value="">-- Select Department --</option>
          {departments.map((dept) => (
            <option key={dept.departmentID} value={dept.departmentID}>
              {dept.departmentName}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-4">
        <label className="form-label">Description</label>
        <input
          type="text"
          className="form-control"
          value={formData.sectionDescription}
          onChange={(e) =>
            setFormData({ ...formData, sectionDescription: e.target.value })
          }
        />
      </div>

      <div className="col-md-2 d-flex align-items-end" >
        {/* <button type="submit" className="btn btn-success me-1">
          {editId ? "Update" : "Add"}
        </button> */}
        {(!editId && hasRight("SectionMaster", "add")) ||
        (editId && hasRight("SectionMaster", "update")) ? (
          <button type="submit" className="btn btn-success me-1">
            {editId ? "Update" : "Add"}
          </button>
        ) : null}

        <button type="button" className="btn btn-secondary" onClick={handleClear}>
          Clear
        </button>
      </div>
    </form>

    {/* Table */}
    <div className="compact-table-container mt-2">
      <table className="compact-table">
        <thead>
          <tr>
            <th>Sr</th>
            <th>Section Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sections.length > 0 ? (
            sections.map((item, index) => (
              <tr key={item.sectionID || index}>
                <td>{index + 1}</td>
                <td>{item.sectionName}</td>
                <td>
                  {/* <button className="edit" onClick={() => handleEdit(item)}>Edit</button>
                  <button className="delete" onClick={() => handleDelete(item.sectionID)}>Delete</button> */}

                  {/* Edit button → only show if user has Update right */}
                  
                  {/* Delete button → only show if user has Delete right */}
                  {hasRight("SectionMaster", "update") && (
                    <button className="edit" onClick={() => handleEdit(item)}>
                      Edit
                    </button>
                  )}
                
                  {hasRight("SectionMaster", "delete") && (
                    <button
                      className="delete"
                      onClick={() => handleDelete(item.sectionID)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">No Sections found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

}
